import React from 'react'
// import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'

import DealsList from './dealsList'
import CreateEditDeal from './createEditDeal'

import { routePrefix } from '../../config';

import './styles.css'
import AuditDeals from './auditDeals';
import { opdbGTM } from '../../utils/pulseUtils';

class DealsContainer extends React.Component {

  componentDidMount() {
    document.title = 'Operator Deals';
    opdbGTM.tabClicked('od_deals_tab_clicked');
  }

  render() {
    return (
      <Switch>
        <Route exact path={routePrefix + '/deals/create'} component={CreateEditDeal} />
        <Route exact path={routePrefix + '/deals/auditlog'} component={AuditDeals} />
        <Route exact path={routePrefix + '/deals/edit/:dealId'} component={CreateEditDeal} />
        <Route path={routePrefix + '/deals'} component={DealsList} />
      </Switch>
    )
  }
}

DealsContainer.propTypes = {}

export default (DealsContainer)
